import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  PayrollDeleteDraftEmployeeGraphQLRequest,
  PayrollDeleteDraftEmployeeResponse,
} from '../types';

const payrollDeleteDraftEmployeeMutation = gql`
  mutation PayrollDeleteDraftEmployee($draftEmployeeId: Int!) {
    payrollDeleteDraftEmployee(draftEmployeeId: $draftEmployeeId) {
      code
      success
      message
    }
  }
`;

export const deleteDraftEmployee = (draftEmployeeId: number) => {
  return graphQLApi<PayrollDeleteDraftEmployeeResponse, PayrollDeleteDraftEmployeeGraphQLRequest>({
    query: payrollDeleteDraftEmployeeMutation,
    queryVariables: { draftEmployeeId },
  });
};
